import * as dateFns from "date-fns";
import { Scalars } from "src/generated/graphqlTypes";
import { Temporal } from "temporal-polyfill";

/** I.e. `01/01/2018` */
export function formatWithYear(date: Scalars["Date"]["input"] | Temporal.ZonedDateTime | undefined | null): string {
  if (!date) return "";
  return dateFns.format(toLegacyDate(date), "MM/dd/yyyy");
}

/** I.e. `01/01/18` */
export function formatWithShortYear(date: Scalars["Date"]["input"]) {
  return dateFns.format(toLegacyDate(date), "MM/dd/yy");
}

/** I.e. `1/1/18` */
export function formatShort(date: Scalars["Date"]["input"]) {
  return dateFns.format(toLegacyDate(date), "M/d/yy");
}

// Ex: Mar 1, 2020
const monthDayYearFormatFns = "MMM d, yyyy";
export function formatMonthDayYear(date: Scalars["Date"]["input"] | Temporal.ZonedDateTime) {
  return dateFns.format(toLegacyDate(date), monthDayYearFormatFns);
}

/** I.e. Jan 1. */
export function formatMonthDay(date: Scalars["Date"]["input"]) {
  return dateFns.format(toLegacyDate(date), "MMM d");
}

/** I.e. January 1. */
export function formatLongMonthDay(date: Scalars["Date"]["input"]) {
  return dateFns.format(toLegacyDate(date), "MMMM d");
}

export function formatDistance(
  from: Temporal.PlainDate | Temporal.ZonedDateTime,
  to: Temporal.PlainDate | Temporal.ZonedDateTime,
  opts?: { addSuffix?: boolean },
) {
  return dateFns.formatDistance(toLegacyDate(from), toLegacyDate(to), opts);
}

export function formatDistanceToNow(date: Temporal.PlainDate | Temporal.ZonedDateTime, opts?: { addSuffix?: boolean }) {
  return dateFns.formatDistanceToNow(toLegacyDate(date), opts);
}

/**
 * Converts either a PlainDate or ZonedDateTime to a legacy date.
 *
 * This should be used as minimally as possible, i.e. only for integration with external
 * Date-based packages like date-fns.
 *
 * PlainDate values are anchored in PT to match the rest of our date-only helpers. Using
 * `new Date(year, month, day)` would reinterpret the same PlainDate in the machine's local
 * timezone, which skews distance math when mixed with PT-based timestamps.
 */
function toLegacyDate(date: Temporal.PlainDate | Temporal.ZonedDateTime): Date {
  return date instanceof Temporal.ZonedDateTime ? date.toLegacyDate() : date.toPT().toLegacyDate();
}

export function formatWithDateAndTime(date: Scalars["Date"]["input"] | Temporal.ZonedDateTime) {
  return dateFns.format(toLegacyDate(date), "MM/dd/yy 'at' h:mmaaa");
}
